import {sendSlackMessageTracked} from "../../models/notifications";


export default function EasyCheckout() {

    function cellView(target) {

        let title = "MORE"
        switch(target) {
            case "site_speed":
                title = <div>Site&nbsp;Speed&nbsp;Optimization</div>
                break
            case "on_site":
                title = <div>Onsite&nbsp;SEO</div>
                break
            case "gkp":
                title = <div>Google&nbsp;Knowledge&nbsp;Panel</div>
                break
            case "local_seo":
                title = <div>Local&nbsp;SEO</div>
                break
            case "geo":
                title = <div>ChatGPT&nbsp;SEO&nbsp;(GEO)</div>
                break
            case "keyword_analysis":
                title = <div>Keyword&nbsp;Analysis</div>
                break
            default:
                title = <div>MORE</div>
                break
        }
        return (
            <a className="button" href={`/services?product_name=${target}`} target="_blank" onClick={() => {
                sendSlackMessageTracked(`Prospect clicked on the easy checkout - item: ${title}`)
            }}>
                <span className="text-sm sm:text-lg">{title}</span>
            </a>
        )
    }

    return (
        <section id="" className="ns-donations alignfull">
            <div className="container">
                <div className="">
                    <h2 className="custom-font"><strong>WIN BIG</strong><br/><strong>WITH SEO.</strong></h2>
                    {/*TODO: Consider putting something here*/}
                </div>
                <div>
                    <div className="btn-group">
                        {cellView("site_speed")}
                        {cellView("on_site")}
                        {cellView("gkp")}
                        {cellView("local_seo")}
                        {cellView("geo")}
                        {cellView("keyword_analysis")}
                    </div>
                </div>
            </div>
        </section>
    )
}